define('nav-bar/nav-bar-store',['require','lodash','api-access','api-access','api-access','lib/models/account/find-expiring-trial','lib/models/account/check-billing-admin','lib/progress-component/show-progress','lib/progress-component/percent-complete','lib/multivariate-testing/multivariate-testing','router/router'],function (require) {
    var _ = require('lodash');
    var user = require('api-access').user;
    var commerceApi = require('api-access').commerce;
    var gotomeet = require('api-access').gotomeet;
    var findExpiringTrial = require('lib/models/account/find-expiring-trial');
    var checkBillingAdmin = require('lib/models/account/check-billing-admin');
    var showProgress = require('lib/progress-component/show-progress');
    var getPercentCompleted = require('lib/progress-component/percent-complete');
    var multivariateTesting = require('lib/multivariate-testing/multivariate-testing');

    require('router/router');

    return {
        // Get only critical data necessary for a faster, initial nav-bar render
        quickFetch: function () {
            var retrieveData = $.Deferred();

            $.when(user.me(), user.settings())
                .then(function (userMeResp, userSettingsResp) {
                    retrieveData.resolve({
                        isAuthenticated: true,
                        user: userMeResp[0],
                        settings: userSettingsResp[0]
                    });
                });

            return retrieveData;
        },

        fetch: function () {
            var promise = $.Deferred();
            var config = {
                isAuthenticated: true
            };

            var authorization;
            var userData;
            var settings;
            var products;
            var hasG2mmProfile;
            var isProgressVisible;
            var percentage;
            var isG2MMSchedulingTest;

            var baseCalls = $.Deferred();
            var productsCall = $.Deferred();
            var gotoMeetCall = $.Deferred();

            $.when(
                user.me(),
                user.settings(),
                showProgress(),
                getPercentCompleted(),
                multivariateTesting.checkVariation('g2mmSchedulingTest')
            )
            .then(function (userResp, settingsResp, progressResp, percentComplete, g2mmSchedulingTestVariation) {
                userData = userResp[0];
                authorization = userData.grantedAuthorities;
                settings = settingsResp[0];
                isG2MMSchedulingTest = g2mmSchedulingTestVariation === 'variation-a';

                // hide GSU for G2MM test user
                isProgressVisible = progressResp && settings.isGSUEnabled && !isG2MMSchedulingTest;
                percentage = percentComplete;

                baseCalls.resolve();
            })
            .fail(baseCalls.reject);

            baseCalls.then(function () {
                commerceApi.getProducts()
                    .then(function (productsResp) {
                        products = productsResp;
                        productsCall.resolve();
                    })
                    .fail(function () {
                        products = [];
                        productsCall.resolve();
                    });
            });

            gotomeet.getByUserKey().done(function () {
                hasG2mmProfile = true;
                gotoMeetCall.resolve();
            }).fail(function () {
                hasG2mmProfile = false;
                gotoMeetCall.resolve();
            });

            $.when(
                baseCalls,
                productsCall,
                gotoMeetCall
            )
            .then(function () {
                var expiringTrial = findExpiringTrial(products);

                return _.extend(config, {
                    authorization: authorization,
                    user: userData,
                    settings: settings,
                    expiringTrial: expiringTrial,
                    hasG2mmProfile: hasG2mmProfile,
                    showBeta: false,
                    showLabs: false,
                    isVoicePlan: settings.nativeEndpointDisabled,
                    setSaleEntitled: settings.setSaleEntitled,
                    setSaleProvisioned: settings.setSaleProvisioned,
                    isBillingAdmin: checkBillingAdmin(products, userData.key),
                    isProgressVisible: isProgressVisible,
                    percentage: percentage
                });
            })
            .then(promise.resolve)
            .fail(promise.reject);

            return promise;
        }
    };
});

